import { render, staticRenderFns } from "./CustomerCustomFieldsCard.vue?vue&type=template&id=24745833&"
import script from "./CustomerCustomFieldsCard.vue?vue&type=script&lang=js&"
export * from "./CustomerCustomFieldsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports